import type { ReactNode } from 'react';
import { PageHeader } from '@/components/ui';

/**
 * סרגל פתיחה של לשונית בתוך מסך הטלפוניה (עיצוב v2): הלשוניות בצד אחד
 * והכפתור הראשי הכחול בצד השני, באותה שורה. כותרת הקטע נשארת לקוראי מסך
 * בלבד (הלשונית הפעילה כבר אומרת איפה אנחנו). בלי לשוניות (מסך עצמאי)
 * חוזרים ל-PageHeader הרגיל.
 */
export function SectionToolbar({ tabs, title, subtitle, actions }: {
  tabs?: ReactNode;
  title: string;
  subtitle?: ReactNode;
  actions?: ReactNode;
}) {
  if (!tabs) return <PageHeader title={title} subtitle={subtitle} actions={actions} />;

  return (
    <div>
      <h2 className="sr-only">{title}</h2>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 'var(--gap)', flexWrap: 'wrap' }}>
        <div style={{ minWidth: 0, maxWidth: '100%' }}>{tabs}</div>
        {actions && <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', marginInlineStart: 'auto' }}>{actions}</div>}
      </div>
      {subtitle && <p style={{ margin: '10px 0 0', color: 'var(--muted)', fontSize: 'var(--t-sm)' }}>{subtitle}</p>}
    </div>
  );
}
